import {
    GoabGrid,
    GoabFormItem,
    GoabInputTel
} from "@abgov/react-components";
import jexl from 'jexl'
import { formatPhoneNumber, validatePhoneInputField } from "../../utils/globalUtility";
import { useEffect, useState } from "react";

export const initializePhoneMobileFields = (fields, data) => {
    fields['mobile'] = data['mobile'] ?? "";
    fields['phone'] = data['phone'] ?? "";
}

const PhoneMobile = ({ form, getResourceValue, context, setFormData, mobile = undefined, phone = undefined, disabled = false }) => {
    const [initialized, setInitialized] = useState(false);

    let mobileValue = undefined;
    if (mobile) {
        mobileValue = jexl.evalSync(mobile, { ...context, form: form.values });
    }

    let phoneValue = undefined;
    if (phone) {
        phoneValue = jexl.evalSync(phone, { ...context, form: form.values });
    }

    useEffect(() => {
        let hasSetValues = false;

        if (mobile) {
            if (!form.values.mobile && !!mobileValue) {
                form.setFieldValue('mobile', mobileValue);
                if (setFormData) {
                    const formValue = { ...form.values, mobile: mobileValue };
                    setFormData(formValue);
                }
            }
            hasSetValues = true;
        }

        if (phone) {
            if (!form.values.phone && !!phoneValue) {
                form.setFieldValue('phone', phoneValue);
                if (setFormData) {
                    const formValue = { ...form.values, phone: phoneValue };
                    setFormData(formValue);
                }
            }
            hasSetValues = true;
        }

        if (hasSetValues && !initialized) {
            setInitialized(true);
        }
    }, [form]);

    useEffect(() => {
        if (initialized) {
            form.validateForm();
        }
    }, [initialized]);

    const handlePhoneFocus = (form, name, value) => {
        form.setFieldValue(name, value.replace(/\D/g, ""));
    }

    const handlePhoneBlur = (form, name, value) => {
        form.setFieldTouched("phone", true);
        form.setFieldTouched("mobile", true);
        const formattedValue = formatPhoneNumber(value);
        if (value.includes(formattedValue)) {
            form.setFieldValue(name, value);
        } else {
            form.setFieldValue(name, formattedValue);
        }
        if (setFormData) {
            const formValue = { ...form.values, [name]: value };
            setFormData(formValue);
        }

        setTimeout(() => form.validateForm());
    };

    let isInputValid = (!form.values.phone && !form.values.mobile) && (form.touched.mobile || form.touched.phone);


    useEffect(() => {
        const mobileInput = document.getElementById("mobileInput");
        if (mobileInput) {
            mobileInput.addEventListener("beforeinput", validatePhoneInputField);
        }

        return () => {
            if (mobileInput) {
                mobileInput.removeEventListener("beforeinput", validatePhoneInputField);
            }
        };

    }, []);

    useEffect(() => {
        const phoneInput = document.getElementById("phoneInput");
        if (phoneInput) {
            phoneInput.addEventListener("beforeinput", validatePhoneInputField);
        }

        return () => {
            if (phoneInput) {
                phoneInput.removeEventListener("beforeinput", validatePhoneInputField);
            }
        };

    }, [])

    return (
        <>
            <GoabGrid gap="m" minChildWidth="200px">
                <GoabFormItem
                    label={getResourceValue({ key: "RESOURCES@form.mobile.label" })}
                    error={
                        (form.errors.mobile &&
                            form.touched.mobile &&
                            getResourceValue({ key: form.errors.mobile }))
                    }
                    id="mobile"
                >
                    <GoabInputTel
                        id="mobileInput"
                        name="mobile"
                        maxLength={14}
                        value={form.values.mobile || mobileValue}
                        disabled={!!mobileValue || disabled}
                        onFocus={({name, value}) => handlePhoneFocus(form, name, value)}
                        onBlur={({name, value}) => handlePhoneBlur(form, name, value)}
                        error={
                            (form.errors.mobile &&
                                form.touched.mobile &&
                                getResourceValue({ key: form.errors.mobile }))
                        }
                       
                    />
                </GoabFormItem>
                <GoabFormItem
                    label={getResourceValue({ key: "RESOURCES@form.phone.label" })}
                    error={
                        (form.errors.phone &&
                            form.touched.phone &&
                            getResourceValue({ key: form.errors.phone }))
                    }
                    id="phone"
                >
                    <GoabInputTel
                        id="phoneInput"
                        name="phone"
                        maxLength={14}
                        value={form.values.phone || phoneValue}
                        disabled={!!phoneValue || disabled}
                        onFocus={({name, value}) => handlePhoneFocus(form, name, value)}
                        onBlur={({name, value}) => handlePhoneBlur(form, name, value)}
                        error={
                            (form.errors.phone &&
                                form.touched.phone &&
                                getResourceValue({ key: form.errors.phone }))
                        }
                    />
                </GoabFormItem>
            </GoabGrid>
            <GoabFormItem
                error={
                    isInputValid ?
                        getResourceValue({ key: "RESOURCES@form.phone.oneRequired" }) : undefined
                }>
            </GoabFormItem>
        </>
    );
};

export default PhoneMobile;
